import React, { Component } from 'react';
import PropTypes from 'prop-types'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions } from '../../actions/locationActions';
import * as types from '../../constants/actionTypes';
import Drawer from '../Common/Drawer/Drawer';
import ListBuilder from '../Common/ListBuilder/ListBuilder';
import LoadingIndicator from '../Common/LoadingIndicator/LoadingIndicator';
import Notification from '../Common/Notification';
import './LocationBaselinesDrawer.scss';
import Moment from 'moment';

export class LocationBaselinesDrawer extends Component {

    constructor(props, context) {
        super(props, context);
        
        this.state = {
            isLoading: false,
            isPushButtonDisabled: false,
            isFormValid: true,
            baselines: [],
            pushedBaselines: [],
            baselinesList: [],
            selectedBaselines: [],
            selectedNewBaseline: null,
            baselinesToPush: [],
            assignTasksAfterPush: false
        };
    }

    componentDidMount() {
        this.loadPushdownFilters();
    }

    loadPushdownFilters = async () => {
        try {
            this.setState({ isLoading: true });
            
            const result = await this.props.actions.loadPushdownFilters(this.props.subscriptionId, this.props.location.id);
            const payload = result.payload;
            if (result.type === types.LOAD_LOCATION_PUSHDOWN_FILTERS_SUCCESS) {
                this.setState({
                    baselines: payload.baselines,
                    pushedBaselines: payload.pushedBaselines
                });
            } else if (result.type === types.LOAD_LOCATION_PUSHDOWN_FILTERS_FAILURE) {
                Notification("error", "An Error Occurred", payload.message)
            }
        } catch (error) {
            Notification("error", "An Error Occurred", error);
        } finally {
            this.setState({ isLoading: false });
        }
    }

    renderBaselinesPushed = () => {
        let options = [];
        this.state.pushedBaselines.forEach(function (option) {
            options.push(
                <tr key={option.id}>
                    <td>{option.name}</td>
                    <td>{Moment(option.datePushed).format('MM/DD/YYYY')}</td>
                    <td>{option.pushedBy}</td>
                </tr>
            );
        });
        return options;
    }

    onCancel = () => {
        this.setState({ isFormValid: true });
        this.props.onCancel();
    }

    onSave = async () => {
        this.setState({ isLoading: true, isPushButtonDisabled: true });

        if (this.state.baselinesToPush.length < 1) {
            this.setState({ isFormValid: false, isLoading: false, isPushButtonDisabled: false });
            return;
        }

        try {
            const requestObj = {
                subscriptionId: this.props.subscriptionId,
                locationId: this.props.location.id,
                baselineIds: this.state.baselinesToPush.map(b => b.id)
            }

            const result = await this.props.actions.pushdown(requestObj);

            if (result.type === types.PUSHDOWN_LOCATION_SUCCESS) {
                Notification("success", "Pushdown Successful", "Baseline pushdown successfull")
                this.setState({ isFormValid: true, baselinesToPush: [] });
                this.props.onComplete(this.state.assignTasksAfterPush);
            } else if (result.type === types.PUSHDOWN_LOCATION_FAILURE) {
                Notification("error", "An Error Occurred", result.payload.message);
                this.setState({ isLoading: false, isPushButtonDisabled: false });
            }
        } catch (error) {
            Notification("error", "An Error Occurred", error);
            this.setState({ isLoading: false, isPushButtonDisabled: false });
        }
    }

    addBaselineToList = (baseline) => {
        this.setState({ baselinesToPush: baseline, isFormValid: true });
    }

    onAssignTasks = () => {
        this.setState({ assignTasksAfterPush: true }, this.onSave);
    }


    render() {

        const customFooter = <div className="button-wrap text-center">
            <button type="button" className="btn btn-primary button--save" onClick={this.onSave} disabled={this.state.isPushButtonDisabled}>Push and Close</button>
            <button type="button" className="btn btn-secondary" onClick={this.onCancel}>Cancel</button>
            <button type="button" className="btn btn-info" onClick={this.onAssignTasks}>Push and Assign Tasks</button>
        </div>

        return (
            <Drawer isWide={true} 
                title={this.props.location.name}
                saveText="Push"
                customFooter={customFooter}
                menuButtons={this.props.menuButtons}
                currentDrawerKey={this.props.currentDrawerKey}
                onCancelClick={this.onCancel} >
                <LoadingIndicator isLoading={this.state.isLoading}>
                    <form noValidate className={this.state.isFormValid ? "location-pushdown-form" : "location-pushdown-form was-validated"}>
                        {this.state.baselines.length > 0 ?
                            <ListBuilder
                                list={this.state.baselines}
                                addToList={this.addBaselineToList}
                                selectLabel="Baselines to Push"
                                selectPlaceholder="Search for a baseline to add..." />
                        : "No baselines were found for this subscription"}
                    </form>
                    <div className="row" id="pushed-baselines">
                        <div className="col">
                            {this.state.pushedBaselines.length > 0 ?
                                <table className="table table-striped table-sm">
                                    <thead>
                                        <tr>
                                            <th scope="col">Name</th>
                                            <th scope="col">Date Pushed</th>
                                            <th scope="col">Pushed By</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.renderBaselinesPushed()}
                                    </tbody>
                                </table>
                            : <div className="alert alert-dark">No baselines have been pushed to this location</div>}
                        </div>
                    </div>
                </LoadingIndicator>
            </Drawer>
        )
    }
}

LocationBaselinesDrawer.propTypes = {
    subscriptionId: PropTypes.string.isRequired,
    location: PropTypes.object.isRequired,
    onComplete: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    menuButtons: PropTypes.array.isRequired,
    currentDrawerKey: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired
};

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch),
    };
}

export default connect(null, mapDispatchToProps)(LocationBaselinesDrawer);
